module.exports = __webpack_public_path__ + "img/top04.3220c86c.png";